import { getConfig } from '@/api/config'

/** Builds a customer route using the saved capitalization of the active company URL name. */
export function companyPath(path: string = '', urlName = getConfig()?.urlName): string {
  if (!urlName) return '/'
  return `/${encodeURIComponent(urlName)}${path && path !== '/' ? (path.startsWith('/') ? path : '/' + path) : ''}`
}

/** Accepts only same-company application destinations, never external or login-loop URLs. */
export function safeCompanyReturn(value: unknown, urlName = getConfig()?.urlName): string | null {
  if (typeof value !== 'string' || !urlName || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return null
  const url = new URL(value, window.location.origin)
  const prefix = companyPath('', urlName)
  if (url.origin !== window.location.origin || !url.pathname.startsWith(prefix + '/')) return null
  const page = url.pathname.slice(prefix.length + 1).split('/')[0]
  if (!['dashboard', 'accounts', 'orders', 'deals', 'proofs'].includes(page)) return null
  return url.pathname + url.search + url.hash
}

/** Returns to company choice with a full reload so loaded stores and pending calls are discarded. */
export function changeCompany(): void {
  window.location.assign('/')
}
